// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","app-wrapper":"App_app-wrapper__uHePm"};